import React, { Suspense, useEffect, useState } from "react";
import { Switch } from "react-router-dom";
import { Route, Redirect } from "react-router-dom";
import SideBar from "../navbar/sidebar";
import Header from "../navbar/header";
import DashBoard from "../views/app/dashboard/myjobs/dashboardjobs";
import JobDetails from "../views/app/dashboard/myjobs/jobdetails";
import SmartResume from "../views/app/dashboard/smartresume/smartresume";
import Search from "../views/app/dashboard/myjobs/search";
import RatingScreen from "../views/app/dashboard/mypeers/ratingscreen";
import BasicInfo from "../views/app/dashboard/myprofile/basicinfo/basicinfo";
import Resume from "../views/app/dashboard/myprofile/resume/resume";
import CandidateSkills from "../views/app/dashboard/myprofile/candskills/candidateskills";
import JOBExperiences from "../views/app/dashboard/myprofile/experience/jobexperiences";
import CandidateEducation from "../views/app/dashboard/myprofile/education/candidateeducation";
import CareerHighlights from "../views/app/dashboard/myprofile/careerhighlights/careerhighlights";
import JobPreferences from "../views/app/dashboard/myprofile/jobpreference/jobpreferences";
import CandidateAddEducation from "../views/app/dashboard/myprofile/education/candidateaddeducation";
import Review from "../views/profile/review";
import PeerRating from "../views/candidateinfo/peerrating";
import AskPeerRating from "../views/candidateinfo/peerrating/AskPeerRating";
import InviteToRatePeers from "../views/candidateinfo/peerrating/invitetoratepeers";
import AppliedJobDetailsScreen from "../views/candidateinfo/appliedjobdetails";
import CandidateAddExperience from "../views/app/dashboard/myprofile/experience/candidateaddexperience";
import Rating from "../views/app/dashboard/mypeers/peerrating";
import { isNullOrEmpty } from "../config/ENV";
import { FaAngleUp } from "react-icons/fa";
import JobSuggestionDetails from "../views/app/dashboard/myjobs/jobsuggestiondetails";
import { ProfileService } from "../services/ProfileService";
import Notifications from "../views/app/dashboard/notifications/notifications";
import { APIResposneService } from "../services/APIResponseService";
import AllJobs from "../views/app/dashboard/AllJobs/allJobs";
import FindJobs from "../views/app/dashboard/FindJobs/findJobs";

import MyProfile from "../views/app/dashboard/myprofile/myProfile";

const DashBoardRoutes = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const scrollToTop = () => {
    const element = document.getElementById("scrollToTop");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const [showTopBtn, setShowTopBtn] = useState(false);
  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 400) {
        setShowTopBtn(true);
      } else {
        setShowTopBtn(false);
      }
    });
  }, []);
  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    getCandidateBasicInfoDetails();
  }, []);

  const getCandidateBasicInfoDetails = () => {
    ProfileService.getBasicInfo().then((response) => {
      try {
        if (response.data !== null) {
          var basicInfoDetails = response.data;
          var basicInfoResponse =
            APIResposneService.getBasicInfoResponse(basicInfoDetails);
          let firstName = basicInfoResponse.firstName;
          let lastName = basicInfoResponse.lastName;
          setFirstName(firstName);
          setLastName(lastName);
        }
        setIsLoading(true);
      } catch (err) {
        setIsLoading(true);
        console.error("getBasicInfo" + err.message);
      }
    });
  };

  return (
    <>
      {isLoading == true ? (
        <>
          <Header />
          <SideBar />
          <div className="t-top-to-btm">
            {" "}
            {showTopBtn && (
              <FaAngleUp
                className="t-icon-position t-icon-style"
                onClick={goToTop}
              />
            )}{" "}
          </div>

          <main>
            <div
              className="bodyContent 
       grid max-md:gap-7 min-md:gap-8 min-xl:gap-12 
       max-lg:grid-cols-1 min-lg:grid-cols-5 min-2xl:grid-cols-3 min-md:absolute 
       min-md:ml-48 min-xl:ml-52 min-md:top-32 -z-10 
       min-md:min-w-[70%] min-lg:min-w-[80%] min-2xl:min-w-[85%] min-md:pr-[3%]"
            >
              {" "}
              <Suspense fallback="loading...">
                <Switch>
                  {!isNullOrEmpty(window.sessionStorage.getItem("wizard")) ? (
                    <Route
                      key="dashboard"
                      exact
                      path="/dashboard"
                      component={DashBoard}
                    />
                  ) : (
                    <Route
                      key="dashboard"
                      exact
                      path="/dashboard"
                      component={DashBoard}
                    />
                  )}
                  <Route
                    key="dashboard"
                    exact
                    path="/dashboard"
                    component={DashBoard}
                  />
                  <Route
                    key="smartresume"
                    path="/smartresume"
                    component={SmartResume}
                  />
                  <Route key="search" path="/search" component={Search} />
                  <Route
                    key="peerrating"
                    path="/peerrating"
                    component={RatingScreen}
                  />
                  <Route key="rating" path="/rating" component={Rating} />
                  <Route
                    key="jobdetails"
                    path="/jobdetails"
                    component={JobDetails}
                  />
                  <Route key="allJobs" path="/allJobs" component={AllJobs} />
                  <Route key="findJobs" path="/findJobs" component={FindJobs} />

                  <Route path="/notifications" component={Notifications} />
                  <Route path="/myProfile/:id" component={MyProfile} />

                  <Route
                    key="Jobsuggestiondetails"
                    path="/Jobsuggestiondetails"
                    component={JobSuggestionDetails}
                  />
                  <Route
                    key="basicinfo"
                    path="/basicinfo"
                    component={BasicInfo}
                  />
                  <Route key="resume" path="/resume" component={Resume} />
                  <Route
                    key="candidateskills"
                    path="/candidateskills"
                    component={CandidateSkills}
                  />
                  <Route
                    key="jobexperiences"
                    path="/jobexperiences"
                    component={JOBExperiences}
                  />

                  <Route
                    key="candidateeducation"
                    path="/candidateeducation"
                    component={CandidateEducation}
                  />
                  <Route
                    key="careerhighlights"
                    path="/careerhighlights"
                    component={CareerHighlights}
                  />
                  <Route
                    key="jobpreferences"
                    path="/jobpreferences"
                    component={JobPreferences}
                  />
                  <Route
                    key="addcandidateeducation"
                    path="/addcandidateeducation"
                    component={CandidateAddEducation}
                  />
                  <Route
                    key="candidateaddexperience"
                    path="/candidateaddexperience"
                    component={CandidateAddExperience}
                  />
                  <Route key="review" path="/review" component={Review} />
                  <Route
                    key="peerrating"
                    path="/peerrating"
                    component={PeerRating}
                  />
                  <Route
                    key="askpeerrating"
                    path="/askpeerrating"
                    component={AskPeerRating}
                  />
                  <Route
                    key="invitetoratepeers"
                    path="/invitetoratepeers"
                    component={InviteToRatePeers}
                  />
                  <Route
                    key="appliedjobdetails"
                    path="/appliedjobdetails"
                    component={AppliedJobDetailsScreen}
                  />
                  {!isNullOrEmpty(window.sessionStorage.getItem("wizard")) ? (
                    <Redirect to="/dashboard" />
                  ) : (
                    <Redirect to="/dashboard" />
                  )}
                </Switch>
              </Suspense>
            </div>
          </main>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default DashBoardRoutes;
